import React, { FC, useEffect } from 'react';
import { setClass, useViewModel } from '@utils';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';
import { ProfileViewModel } from '@views';
import { Button } from '../button';
import { NotificationSetting } from '../notificationSetting';
import { NotificationSettings } from '../notificationSetting/NotificationSettings';
import { Select } from '../select2';
import '../../styles/components/profileTabs.scss';

export const NotificationSettingsTab: FC = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);

  useEffect(() => {
    return () => {
      profileViewModel.editNewNotification(null);
    };
  }, []);

  const renderOption = (option: number) => {
    if (option === -1) {
      return <p className="select-option">Отключены</p>;
    }
    if (option === 0) {
      return <p className="select-option">Включены</p>;
    }
    if (option % 1440 === 0) {
      return <p>{`Отключены на ${option / 1440} д.`}</p>;
    }
    if (option % 60 === 0) {
      return <p className="select-option">{`Отключены на ${option / 60} ч.`}</p>;
    }
    return <p className="select-option">{`Отключены на ${option} мин.`}</p>;
  };

  return (
    <div className={setClass(isMobile && 'mobile-wrapper')}>
      <h4 className="advanced-info">Уведомления о встречах</h4>
      <NotificationSettings
        notifications={profileViewModel.notifications}
        editNotification={profileViewModel.editNotification}
        deleteNotification={profileViewModel.deleteNotification}
      />
      {profileViewModel.newNotification
        ? (
          <NotificationSetting
            isNew
            notification={profileViewModel.newNotification}
            onChange={profileViewModel.editNewNotification}
            onClose={profileViewModel.changeNewNotificationVisibility}
            onSave={profileViewModel.addNotification}
          />
        )
        : (
          <Button
            className="outlined"
            onClick={profileViewModel.changeNewNotificationVisibility}
            title="Добавить уведомление"
          />
        )}
      <h4 className={setClass('advanced-info', isMobile && 'mobile')}>Оповещения</h4>
      <div className="select-alert">
        <Select
          value={profileViewModel.reminderOffMinutes}
          commonContent
          defaultValue={profileViewModel.reminderOffMinutes}
          options={[0, -1, 60]}
          placeholder="Время"
          onChange={profileViewModel.changeAlertsState}
          renderOption={renderOption}
          customOption="Отключить на..."
        />
      </div>
    </div>
  );
});
